<template>
    <div class="js-tabs__content">
        <keep-alive>
            <icon-panel
                    :position="position"
                    :customization="iconCustomizationAttribute"
                    :color-attribute="colorAttribute"
                    :scales="scaleOptions"
                    @selected:color="colorSelectedHandler"
                    @selected:scale="scaleSelectedHandler"
            ></icon-panel>
        </keep-alive>

        <keep-alive>
            <upload-panel
                    :position="position"
                    :customization="uploadCustomizationAttribute"
                    :color-attribute="colorAttribute"
                    :scales="scaleOptions"
                    @selected:color="colorSelectedHandler"
                    @selected:scale="scaleSelectedHandler"
            ></upload-panel>
        </keep-alive>

        <keep-alive>
            <text-panel
                    :position="position"
                    :customization="textCustomizationAttribute"
                    :color-attribute="colorAttribute"
                    @selected:color="colorSelectedHandler"
            ></text-panel>
        </keep-alive>

        <p>
            Drucktechnisch bedingt kann es zu handelsüblichen Abweichungen bei Ausführungen, Farb- und Formgebungen
            zwischen Abbildungen im Online-Konfigurator und dem fertigen Produkt kommen.
            <br><br>
            Mit der Beauftragung der Personalisierung erklären Sie ausdrücklich zur Verwendung der Personalisierung
            sowie der zur Personalisierung vorgelegten Bilder, Designs oder Schriftzüge berechtigt zu sein und diese
            nutzen zu dürfen.
        </p>

        <button type="button" class="button button--reset" @click="resetPositionClickHandler" id="mytw_reset_position">
            <span>Position zurücksetzen</span>
        </button>

        <ui-modal v-show="showResetModal" @close:clicked="showResetModal = false">
            <template v-slot:title>Position zurücksetzen</template>
            <template v-slot:content>
                <p>
                    Sind Sie sich sicher, dass Sie die Personalisierung für diese Position zurücksetzen möchten?
                </p>
            </template>
            <template v-slot:footer>
                <button type="button" class="button button--white button--outline button--modal"
                        @click="showResetModal = false">
                    <span>abbrechen</span>
                </button>
                <button type="button" class="button button--white button--outline button--modal button--modal--primary"
                        @click="confirmResetClickhandler">
                    <span>ja, Position zurücksetzen</span>
                </button>
            </template>
        </ui-modal>
    </div>
</template>

<script>
    import IconPanel   from "./position/IconPanel"
    import TextPanel   from "./position/TextPanel"
    import UploadPanel from "./position/UploadPanel"

    export default {
        name:       "PositionCustomization",
        components: {
            IconPanel,
            TextPanel,
            UploadPanel,
        },
        props:      {
            'position': {
                required: true
            }
        },
        data:       function () {
            return {
                iconOptions:      [],
                iconAttributeId:  null,
                colorAttribute:   null,
                scaleOptions:     [],
                scaleAttributeId: null,

                customizationOptionsNode:     null,
                iconCustomizationAttribute:   null,
                uploadCustomizationAttribute: null,
                textCustomizationAttribute:   null,
                noneCustomizationAttribute:   null,
                materialOptionsAttributeId:   null,

                showResetModal: false,
            }
        },
        created:    function () {
            this.colorAttribute = this.position.filterByType('mytw_conf_position_color')
            this.loadCustomizationOptions()
            this.loadScales()
        },
        computed:   {
            positionSlug: function () {
                return this.position.getRoot().getSlug()
            },

            hasCustomization: function () {
                return this.callStoreGetter('hasCustomization')
            },

            hasIconCustomization: function () {
                return this.callStoreGetter('hasIconCustomization')
            },

            hasUploadCustomization: function () {
                return this.callStoreGetter('hasUploadCustomization')
            },

            hasTextCustomization: function () {
                return this.callStoreGetter('hasTextCustomization')
            },

            hasNoneCustomization: function () {
                return this.callStoreGetter('hasNoneCustomization')
            },

            hasColor: function () {
                return this.callStoreGetter('hasColor')
            },

            hasScale: function () {
                return this.callStoreGetter('hasScale')
            }
        },
        methods:    {

            /**
             * Call a store getter
             */
            callStoreGetter(getterName) {
                let slug = this.positionSlug
                return this.$store.getters[slug + '/' + getterName]
            },

            /**
             * Call a store mutation
             */
            callStoreMutation(mutationName, payload) {
                let slug = this.positionSlug
                return this.$store.commit(slug + '/' + mutationName, payload)
            },

            /**
             * Load the customizationType options
             */
            loadCustomizationOptions: function () {
                let customizationOptionsNode  = this.position.filterByType('mytw_conf_position_customization')
                let options                   = customizationOptionsNode.getAttributeValues()
                this.customizationOptionsNode = customizationOptionsNode

                options.forEach(attribute => {
                    let description = attribute.getDescription()
                    switch (description) {
                        case 'mytw_conf_position_customization_icon':
                            this.iconCustomizationAttribute = attribute
                            break
                        case 'mytw_conf_position_customization_upload':
                            this.uploadCustomizationAttribute = attribute
                            break
                        case 'mytw_conf_position_customization_text':
                            this.textCustomizationAttribute = attribute
                            break
                        case 'mytw_conf_position_customization_position':
                            this.noneCustomizationAttribute = attribute
                            break
                        case 'mytw_conf_position_customization_none':
                            this.noneCustomizationAttribute = attribute
                            break
                    }
                })
            },

            /**
             * Load the available scales from the position
             *
             * TODO: Preselected scale
             */
            loadScales: function () {
                let node = this.position.filterByType('mytw_conf_position_scale')

                if (node && node.hasAttributeValues()) {
                    this.scaleOptions     = node.getAttributeValues()
                    this.scaleAttributeId = node.getId()

                    let defaultScale = node.getDefaultAttributeValue() ? node.getDefaultAttributeValue() : this.scaleOptions[0];

                    this.updateScale(defaultScale);
                }
            },

            /**
             * Updates the selected color in the store and applys it to expivi
             */
            colorSelectedHandler: function (color) {
                this.updateColor(color)
            },

            /**
             * Updates the scale in the store and applys it to expivi
             */
            scaleSelectedHandler: function (scale) {
                this.$expiviReady.then(expivi => {
                    this.updateScale(scale)
                    expivi.setProductAttribute(this.scaleAttributeId, scale.getId())
                })
            },

            /**
             * Reset all customizations if the user confirmed the reset
             */
            confirmResetClickhandler: function () {
                if (!this.hasNoneCustomization) {
                    this.resetPosition()
                    this.addDataLayer({
                        'event': 'mytw_reset_position_confirm'
                    });

                    this.showResetModal = false
                }
            },

            /**
             * Resets the position
             */
            resetPosition: function () {

                this.updateCustomization(this.noneCustomizationAttribute)
                this.$expiviReady.then(expivi => expivi.setProductAttribute(
                    this.customizationOptionsNode.getId(), this.noneCustomizationAttribute.getId()
                ))
            },

            /**
             * Maps the updateColor mutation of the dynamic store module
             *
             * @param color
             */
            updateColor: function (color) {
                this.callStoreMutation('updateColor', color)
            },

            /**
             * Maps the updateScale mutation of the dynamic store module
             *
             * @param scale
             */
            updateScale: function (scale) {
                this.callStoreMutation('updateScale', scale)
            },

            /**
             * Update the customizationType
             *
             * @param customization
             */
            updateCustomization: function (customization) {
                this.callStoreMutation('updateCustomization', customization)
            },

            /**
             * Handles the click on the reset button and displays the modal to confirm the resetting of the position.
             */
            resetPositionClickHandler: function () {
                this.addDataLayer({
                    'event': 'mytw_reset_position'
                });
                this.showResetModal = true
            }
        }
    }
</script>

<style scoped>

</style>
